"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsGrid2 = exports.PRODUCTS_GRID_2_SELECT = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const views2_1 = require("./views2");
const EmptyInfo_1 = require("../EmptyInfo");
const hooks_1 = require("../lib/hooks");
const productTile_1 = require("../productTile");
exports.PRODUCTS_GRID_2_SELECT = {
    id: true,
    slug: true,
    title: true,
    images: true,
    category: {
        title: true,
    },
    price: {
        amount: true,
        currency: true,
        otherPrices: true,
        discountedPrice: true,
        hidden: true,
    },
};
function ProductsGrid2({ categoryMapper = (category) => [category], selectExtend, productTile = productTile_1.ProductTileView2, defaultSort, }) {
    const { t } = (0, app_1.useTranslation)();
    const { category, params, ready } = (0, hooks_1.useSearchMeta)();
    const queryTake = 12;
    const saleFilter = category === 'sale';
    const { sort, sortOrder, search } = params, attributes = __rest(params, ["sort", "sortOrder", "search"]);
    const { data: products, loading, error, fetchMore, } = (0, app_1.useQuery)('getProducts', {
        withoutArgs: 'WAIT',
        args: ready
            ? Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (sort
                ? { sort: { by: sort, order: sortOrder !== null && sortOrder !== void 0 ? sortOrder : 'desc' } }
                : defaultSort
                    ? { sort: defaultSort }
                    : {})), { take: queryTake, title: search !== null && search !== void 0 ? search : '' }), (saleFilter && { onSale: saleFilter })), (category && !saleFilter
                ? { categories: categoryMapper(category) }
                : {})), { byAttributes: Object.entries(attributes).map(([key, value]) => ({
                    attribute: key,
                    values: typeof value === 'string' ? [value] : value,
                })) }) : null,
        select: Object.assign(Object.assign({}, exports.PRODUCTS_GRID_2_SELECT), selectExtend),
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(views2_1.ProductsGridView2, { products: (products !== null && products !== void 0 ? products : []), productTile: productTile, onLoadMore: () => fetchMore({ after: products === null || products === void 0 ? void 0 : products[products.length - 1].id }), loading: loading }), ((!loading && (products === null || products === void 0 ? void 0 : products.length) === 0) || error) && ((0, jsx_runtime_1.jsx)(EmptyInfo_1.EmptyInfo.Margin, { children: (0, jsx_runtime_1.jsx)(EmptyInfo_1.EmptyInfo, { title: t('error.noResults'), svg: svg_1.SvgInfo }) }))] }));
}
exports.ProductsGrid2 = ProductsGrid2;
